import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { DialogConfirmComponent } from '../dialog-confirm/dialog-confirm.component';
import { EditThropyComponent } from './edit-thropy/edit-thropy.component';
import { NewThropyComponent } from './new-thropy/new-thropy.component';

@Component({
  selector: 'vex-thropies',
  templateUrl: './thropies.component.html',
  styleUrls: ['./thropies.component.scss']
})
export class ThropiesComponent implements OnInit {
  searchCtrl = new UntypedFormControl();
  pageSize = 10;
  pageNumber = 1;
  pageSizeOptions: number[] = [5, 10, 15, 50];
  lunghezza: any;
  dataSource: MatTableDataSource<any> | null
  displayedColumns: string[] = ['title', 'draft', 'type', 'actions'];
  trophies;
  @ViewChild(MatTable) table: MatTable<any>;

  constructor(public translate: TranslateService, public guiService: GuiService, private restService: RestService, private dialog: MatDialog) { }

  ngOnInit(): void {
    if (this.guiService.userLogged) {
      this.search();
    } else {
      this.getCurrent();
    }
  }

  getCurrent() {
    this.restService.getService('current_user', '').subscribe((ris) => {
      this.guiService.userLogged = ris;
      this.search();
    })
  }

  search(){
    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.dataSource = new MatTableDataSource();
    const param = {
      page: this.pageNumber,
      size: this.pageSize
    };
    this.searchCtrl.value && this.searchCtrl.value !== '' ? (param['langKey'] = this.translate.currentLang.toUpperCase(), param['i18nTitleFilter'] = this.searchCtrl.value) : null;

    this.restService.postServiceUserId('node', '/get-trophies',param, this.guiService.userLogged.user.id).subscribe((ris)=>{
      this.trophies = ris.items;
      this.lunghezza = ris.totalItems
      this.dataSource.data = this.trophies;
      this.table ? this.table.renderRows() : null;
      this.guiService.showSpinner = false
    })
  }

  reload() {
    this.searchCtrl.reset();

    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.dataSource = new MatTableDataSource();
    const param = {
      page: 1,
      size: this.pageSize
    };
    this.restService.postServiceUserId('node', '/get-trophies',param, this.guiService.userLogged.user.id).subscribe((ris)=>{
      this.trophies = ris.items;
      this.lunghezza = ris.totalItems
      this.dataSource.data = this.trophies;
      this.table ? this.table.renderRows() : null;
      this.guiService.showSpinner = false
    })
  }

  resetPage() {
    this.pageNumber = 1;
  }

  onPageChanged(pageEvent: PageEvent) {
    this.pageNumber = pageEvent.pageIndex + 1;
    this.pageSize = pageEvent.pageSize;
    this.search();
  }

  createTrophy() {
    this.dialog.open(NewThropyComponent, {
      height: '85vh',
      panelClass: 'custom-modalboxx',
      disableClose: true,
      hasBackdrop: true
    }).afterClosed().subscribe((sub) => {
      if (sub == 'done') {
        this.search();
      }
    })
  }

  deleteTrophy(id) {
    this.dialog.open(DialogConfirmComponent, {
      width: '250px',
      enterAnimationDuration: '0ms',
      exitAnimationDuration: '1ms',
      panelClass: 'dialog-modalbox',
      data: {
        type: 'node-delete-trophy',
        id: id
      }
    }).afterClosed().subscribe((ris) => {
      if (ris != 'true') {
        this.search()
      }
    })
  }

  editTrophy(item?: any['item']) {
    this.dialog.open(EditThropyComponent, {
      data: item || null,
      height: '85vh',
      panelClass: 'custom-modalboxx',
      disableClose: true,
      hasBackdrop: true
    }).afterClosed().subscribe((program) => {
      if (program == 'done') {
        this.search()
      }
    })
  }

}
